import { Grid, Input, Table } from "semantic-ui-react";
import "./packagingTable.scss";
import Icon from "@mdi/react";
import { mdiDeleteOutline, mdiContentSave } from "@mdi/js";
import { DropDown, InputText } from "../../../../components";
import InputWithDropDown from "../../../../components/inputWithDropDown/InputWithDropDown";
import { WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM } from "../../../../config/optionsConstants";
import { InputNumber } from "../../../../components/InputText/InputNumber";

const NewPackagingRow = ({
  newRow,
  packagingMaterials,
  handleInputChange,
  handleDropdownChange,
  register,
  control,
  errors,
  handleAddPackagingData,
  setNewRow
}: any) => {
  if (!newRow) return null;

  return (
    <Table.Row>
      <Table.Cell>
        <InputText
          register={register}
          errors={errors.packageName}
          placeholder="Packaging Name"
          name="packageName"
          required={true}
          errorMessage="Packaging name is required"
          onChangeFunction={e => handleInputChange("newRow", "packageName", e.target.value)}
        />
      </Table.Cell>
      <Table.Cell>
        <DropDown
          customGridMain="custom-grid-main"
          placeholder="Packaging Material"
          currentData={packagingMaterials}
          defaultValue={
            newRow.packageMaterial !== undefined && packagingMaterials?.[newRow.packageMaterial]
              ? packagingMaterials[newRow.packageMaterial].value
              : undefined
          }
          customGridColumn={"customGridColomnType"}
          handleChangeState={(e, { value }) =>
            handleDropdownChange("newRow", "packageMaterial", value)
          }
        />
      </Table.Cell>
      <Table.Cell>
        <InputWithDropDown
          defaultSelectValue={1}
          options={WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM}
          selectOption={(value: number) => handleDropdownChange("newRow", "weightUnit", value)}
          control={control}
          errors={errors.materialWeight}
          placeholder="0.00"
          name="materialWeight"
          required={true}
          errorMessage="Material Weight is required"
          onChangeFunction={(e: React.ChangeEvent<HTMLInputElement>) => {
            handleInputChange("newRow", "materialWeight", e.target.value);
          }}
        />
      </Table.Cell>
      <Table.Cell>
        <InputNumber
          control={control}
          errors={errors.materialCost}
          placeholder="0.00"
          name="materialCost"
          required={false}
          errorMessage="Material Cost is required"
          onChangeFunction={(e: React.ChangeEvent<HTMLInputElement>) => {
            handleInputChange("newRow", "materialCost", e.target.value);
          }}
        />
      </Table.Cell>
      <Table.Cell>
        <Grid>
          <Grid.Column width={8}>
            <div onClick={handleAddPackagingData}>
              <Icon
                className="table-icon"
                color="var(--tableEditIcon)"
                path={mdiContentSave}
                size={1.2}
              />
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <div onClick={() => setNewRow(undefined)}>
              <Icon
                className="table-icon"
                color="var(--tableEditIcon)"
                path={mdiDeleteOutline}
                size={1.2}
              />
            </div>
          </Grid.Column>
        </Grid>
      </Table.Cell>
    </Table.Row>
  );
};

export default NewPackagingRow;
